import type { ReactNode } from 'react';
import { FiX } from 'react-icons/fi';

interface BottomBannerProps {
  title: ReactNode;
  description: ReactNode;
  /** Botão de ação primária — omitido quando o banner é só informativo. */
  actionLabel?: ReactNode;
  actionIcon?: ReactNode;
  onAction?: () => void;
  actionDisabled?: boolean;
  onDismiss: () => void;
  testId: string;
}

/**
 * Base única dos banners globais de rodapé (instalação do PWA, ativação de
 * push, futuros). Apenas apresentação — visibilidade e lógica ficam em cada
 * wrapper. Tema claro fixo (overlay global, mesmo racional de modais).
 */
export function BottomBanner({
  title,
  description,
  actionLabel,
  actionIcon,
  onAction,
  actionDisabled,
  onDismiss,
  testId,
}: BottomBannerProps) {
  return (
    <div
      data-testid={testId}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        padding: '16px',
        background: '#ffffff',
        borderTop: '1px solid #e2e8f0',
        boxShadow: '0 -4px 12px rgba(0,0,0,0.1)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', maxWidth: '600px', margin: '0 auto' }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '14px', fontWeight: 600, color: '#1e293b', marginBottom: '2px' }}>
            {title}
          </div>
          <div style={{ fontSize: '12px', color: '#64748b' }}>
            {description}
          </div>
        </div>

        {actionLabel && onAction && (
          <button
            onClick={onAction}
            disabled={actionDisabled}
            data-testid={`${testId}-action`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              background: '#8b5cf6',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 16px',
              fontSize: '13px',
              fontWeight: 500,
              cursor: actionDisabled ? 'wait' : 'pointer',
              whiteSpace: 'nowrap',
              opacity: actionDisabled ? 0.7 : 1,
            }}
          >
            {actionIcon}
            {actionLabel}
          </button>
        )}

        <button
          onClick={onDismiss}
          data-testid={`${testId}-dismiss`}
          style={{
            background: 'none',
            border: 'none',
            color: '#94a3b8',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
          }}
        >
          <FiX size={18} />
        </button>
      </div>
    </div>
  );
}
